import {Component, ChangeDetectionStrategy, AfterViewInit} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
  selector: 'dux-custom-editor',
  templateUrl: './custom-editor.component.html',
  styleUrls: ['./custom-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomEditorComponent implements ICellEditorAngularComp, AfterViewInit {

    public selectedCategory: any;
    public categoryList: any;

    ngAfterViewInit(): void {
    }


    agInit(params: any): void {
        this.selectedCategory = params.value;
        this.categoryList = params.values;
    }


    getValue(): any {
        return this.selectedCategory;
    }

    isPopup(): boolean {
        return false;
    }

}
